__turbopack_context__.v({
  "arrow": "main-sidebar-footer-module-sass-module__fTK86q__arrow",
  "list": "main-sidebar-footer-module-sass-module__fTK86q__list" + " " + __turbopack_context__.i(267166)["list"],
  "mainMenuItem": "main-sidebar-footer-module-sass-module__fTK86q__mainMenuItem",
  "popoverContent": "main-sidebar-footer-module-sass-module__fTK86q__popoverContent" + " " + __turbopack_context__.i(488939)["popoverContent"],
  "selected": "main-sidebar-footer-module-sass-module__fTK86q__selected" + " " + __turbopack_context__.i(267166)["selected"],
  "separator": "main-sidebar-footer-module-sass-module__fTK86q__separator",
});
